module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container",
    attrs: {
      "id": "mobileViewPort"
    }
  }, [_c('div', {
    attrs: {
      "id": "mobileMode"
    }
  }, [_c('div', {
    attrs: {
      "id": "titleArea"
    }
  }, [_c('div', {
    staticClass: "titleText"
  }, [_vm._v("评教服务")]), _vm._v(" "), _c('div', {
    staticClass: "titleButton"
  }, [_c('el-button', {
    staticClass: "custom-el-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showHomePage
    }
  }, [_c('i', {
    staticClass: "el-icon-s-home"
  }), _vm._v(" 首页\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "margin-left": "5%",
      "margin-bottom": "10px"
    }
  }, [(!_vm.generalFlag) ? _c('el-input', {
    attrs: {
      "placeholder": "教师姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.queryGenForm.jsxm),
      callback: function($$v) {
        _vm.$set(_vm.queryGenForm, "jsxm", $$v)
      },
      expression: "queryGenForm.jsxm"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "formItem text-center"
  }, [(_vm.generalFlag) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        _vm.createDialogVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-edit"
  }), _vm._v(" 参与评教\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.tjxxFlag && _vm.generalFlag && _vm.statisticsButtonVisible) ? _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.openGeneral
    }
  }, [_c('i', {
    staticClass: "el-icon-tickets"
  }), _vm._v(" 统计信息\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.generalFlag) ? _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.generalFlag) ? _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.generalFlag) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible.queryDialogVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-more"
  }), _vm._v(" 更多\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.generalFlag) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.backToMain
    }
  }, [_c('i', {
    staticClass: "el-icon-back"
  }), _vm._v(" 返回\n                    ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "queryDialog",
      "title": "查询信息",
      "width": "90%",
      "visible": _vm.dialogVisible.queryDialogVisible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogVisible, "queryDialogVisible", $event)
      }
    }
  }, [_c('el-row', [_c('el-select', {
    attrs: {
      "placeholder": "学年学期",
      "clearable": ""
    },
    model: {
      value: (_vm.queryGenForm.xnxqbm),
      callback: function($$v) {
        _vm.$set(_vm.queryGenForm, "xnxqbm", $$v)
      },
      expression: "queryGenForm.xnxqbm"
    }
  }, _vm._l((_vm.comboData.semester), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-input', {
    attrs: {
      "placeholder": "教师工号",
      "clearable": ""
    },
    model: {
      value: (_vm.queryGenForm.jsbh),
      callback: function($$v) {
        _vm.$set(_vm.queryGenForm, "jsbh", $$v)
      },
      expression: "queryGenForm.jsbh"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-input', {
    attrs: {
      "placeholder": "教师姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.queryGenForm.jsxm),
      callback: function($$v) {
        _vm.$set(_vm.queryGenForm, "jsxm", $$v)
      },
      expression: "queryGenForm.jsxm"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_vm._v("查 询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v("重 置")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible.queryDialogVisible = false
      }
    }
  }, [_vm._v("取 消\n                ")])], 1)], 1), _vm._v(" "), (!_vm.generalFlag) ? _c('div', {
    attrs: {
      "id": "listArea"
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.genTableData == null || _vm.genTableData.length == 0) ? _c('div', {
    staticClass: "cardTips"
  }, [_vm._v("暂无数据")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.genTableData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cardMain"
    }, [_c('div', {
      staticClass: "cardText"
    }, [_c('p', [_vm._v(_vm._s(item.xnxqmc))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("教师工号：")]), _vm._v(_vm._s(item.jsbh))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("教师姓名：")]), _vm._v(_vm._s(item.jsxm))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("总       分：")]), _vm._v(_vm._s(item.zf))])]), _vm._v(" "), _c('div', {
      staticClass: "cardInput"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.handleEdit(item.jsxm, item.jsbh, item.xnxqbm)
        }
      }
    }, [_vm._v("操作")])], 1)])
  }), _vm._v(" "), (_vm.total > 2 && _vm.total > _vm.genTableData.length) ? _c('div', {
    attrs: {
      "id": "loadingTips"
    }
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" 信息加载中，请稍候...\n            ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": _vm.genTitle,
      "width": "90%",
      "visible": _vm.dialogVisible.generalInfo
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogVisible, "generalInfo", $event)
      }
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "mainDialogScroll"
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "left",
      "width": "100%"
    }
  }, [(_vm.detailsTable == null || _vm.detailsTable.length == 0) ? _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "490px"
    },
    attrs: {
      "id": "listArea"
    }
  }, [_c('div', {
    staticClass: "cardTips"
  }, [_vm._v("暂无数据")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.detailsTable), function(item, index) {
    return [(index != 0) ? _c('div', [_c('el-divider')], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "评价表名称"
      }
    }, [_vm._v("\n                            " + _vm._s(item.pjbmc) + "\n                        ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "最高分"
      }
    }, [_vm._v("\n                                    " + _vm._s(item.max) + "\n                                ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "评教人数"
      }
    }, [_vm._v("\n                                    " + _vm._s(item.pjrs) + "\n                                ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "最低分"
      }
    }, [_vm._v("\n                            " + _vm._s(item.min) + "\n                        ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "平均分"
      }
    }, [_vm._v("\n                                    " + _vm._s(item.avg) + "\n                                ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [(item.lx == '03') ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.tkHandleEdit()
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-tickets"
    }), _vm._v(" 详情\n                                ")]) : _vm._e()], 1)], 1)]
  })], 2)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "queryDialog",
      "title": "评教",
      "width": "90%",
      "visible": _vm.createDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.createDialogVisible = $event
      },
      "open": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "queryQueForm",
    attrs: {
      "model": _vm.queryQueForm,
      "label-position": "left"
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "prop": "semesterCode",
      "rules": [{
        required: true,
        message: '请选择学年学期'
      }]
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "学年学期",
      "clearable": ""
    },
    model: {
      value: (_vm.queryQueForm.semesterCode),
      callback: function($$v) {
        _vm.$set(_vm.queryQueForm, "semesterCode", $$v)
      },
      expression: "queryQueForm.semesterCode"
    }
  }, _vm._l((_vm.comboData.semester), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "prop": "type",
      "rules": [{
        required: true,
        message: '请选择评教类型'
      }]
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.typeTips,
      "disabled": _vm.typeDisable,
      "clearable": ""
    },
    model: {
      value: (_vm.queryQueForm.type),
      callback: function($$v) {
        _vm.$set(_vm.queryQueForm, "type", $$v)
      },
      expression: "queryQueForm.type"
    }
  }, _vm._l((_vm.comboData.type), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createEvaluate
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.createDialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), (_vm.generalFlag) ? _c('div', {
    staticClass: "mainList",
    attrs: {
      "id": "listArea"
    }
  }, [(_vm.queInfo.length == 0) ? _c('div', {
    staticClass: "cardTips"
  }, [_vm._v("没有可查看的评教信息")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.queInfo), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cardMain"
    }, [_c('div', {
      staticClass: "cardText"
    }, [_c('p', [_vm._v(_vm._s(item.xnxqmc))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("评教名称：")]), _vm._v(_vm._s(item.pjbmc))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("评教时间：")]), _vm._v(_vm._s(item.pjsj))])]), _vm._v(" "), _c('div', {
      staticClass: "cardInput"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.showDetailInfo(item.id, item.lx)
        }
      }
    }, [_vm._v("详情")])], 1)])
  })], 2) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": "教师教学质量听课评价",
      "visible": _vm.dialogVisible.tkEvaluate,
      "close-on-click-modal": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogVisible, "tkEvaluate", $event)
      },
      "open": _vm.openTk,
      "close": _vm.closeTkEvaluate
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "mainDialogScroll"
    }
  }, [_c('el-form', {
    ref: "tkForm",
    attrs: {
      "model": _vm.tkForm,
      "label-width": "96px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学年学期"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.semesterName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "教师类型",
      "prop": "teaType",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.tkForm.teaType),
      callback: function($$v) {
        _vm.$set(_vm.tkForm, "teaType", $$v)
      },
      expression: "tkForm.teaType"
    }
  }, _vm._l((_vm.tkComboData.teaType), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程类型",
      "prop": "courseType",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.tkForm.courseType),
      callback: function($$v) {
        _vm.$set(_vm.tkForm, "courseType", $$v)
      },
      expression: "tkForm.courseType"
    }
  }, _vm._l((_vm.tkComboData.courseType), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "教师姓名",
      "prop": "teaCode",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-select', {
    ref: "select",
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.tkTeaChange,
      "hook:mounted": _vm.cancalReadOnly,
      "visible-change": _vm.cancalReadOnly
    },
    model: {
      value: (_vm.tkForm.teaCode),
      callback: function($$v) {
        _vm.$set(_vm.tkForm, "teaCode", $$v)
      },
      expression: "tkForm.teaCode"
    }
  }, _vm._l((_vm.tkComboData.teaName), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "教师所在系部",
      "prop": "szxbName"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkForm.szxbName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程名称",
      "prop": "courseCode",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "change": _vm.tkCourseChange
    },
    model: {
      value: (_vm.tkForm.courseCode),
      callback: function($$v) {
        _vm.$set(_vm.tkForm, "courseCode", $$v)
      },
      expression: "tkForm.courseCode"
    }
  }, _vm._l((_vm.tkComboData.course), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "听课班级"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkForm.tkbjName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    ref: "select",
    attrs: {
      "label": "听课地点",
      "prop": "tkdd",
      "rules": [{
        required: true,
        message: ' '
      }]
    },
    on: {
      "hook:mounted": _vm.cancalReadOnly,
      "visible-change": _vm.cancalReadOnly
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.tkForm.tkdd),
      callback: function($$v) {
        _vm.$set(_vm.tkForm, "tkdd", $$v)
      },
      expression: "tkForm.tkdd"
    }
  }, _vm._l((_vm.tkComboData.tkdd), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "听课时间",
      "prop": "sj",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.tkForm.sj),
      callback: function($$v) {
        _vm.$set(_vm.tkForm, "sj", $$v)
      },
      expression: "tkForm.sj"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "听课节次",
      "prop": "jc",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.tkForm.jc),
      callback: function($$v) {
        _vm.$set(_vm.tkForm, "jc", $$v)
      },
      expression: "tkForm.jc"
    }
  }, _vm._l((_vm.tkComboData.jc), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应到学生数",
      "prop": "ydxss"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkForm.ydxss) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实到学生数",
      "prop": "sdxss"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.tkForm.sdxss),
      callback: function($$v) {
        _vm.$set(_vm.tkForm, "sdxss", $$v)
      },
      expression: "tkForm.sdxss"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "迟到学生数",
      "prop": "cdxss"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.tkForm.cdxss),
      callback: function($$v) {
        _vm.$set(_vm.tkForm, "cdxss", $$v)
      },
      expression: "tkForm.cdxss"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评分"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "tkFormS",
    attrs: {
      "model": _vm.tkForm,
      "label-width": "120px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_vm._l((_vm.pjxData), function(item, index) {
    return [_c('el-form-item', {
      attrs: {
        "label": item.pjxmc,
        "prop": 'dfArr[' + index + ']',
        "rules": [{
          required: true,
          message: ' '
        }]
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.openTkInfo(index)
        }
      }
    }, [_vm._v("详情")]), _vm._v(" "), _c('el-input-number', {
      staticStyle: {
        "margin-left": "10px",
        "width": "100px"
      },
      attrs: {
        "size": "mini",
        "min": 0,
        "max": parseInt(_vm.pjxData[index].qz)
      },
      on: {
        "input": function($event) {
          return _vm.tkChangeDf($event, _vm.pjxData[index].bh)
        }
      },
      model: {
        value: (_vm.tkForm.dfArr[index]),
        callback: function($$v) {
          _vm.$set(_vm.tkForm.dfArr, index, $$v)
        },
        expression: "tkForm.dfArr[index]"
      }
    })], 1)]
  })], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合计",
      "prop": "hj"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.hjdf) + "\n                    ")]), _vm._v(" "), _c('el-form', {
    ref: "tkForm",
    attrs: {
      "model": _vm.tkForm,
      "label-width": "96px",
      "label-position": "top",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "综合评价与建议",
      "prop": "zhpjjy"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 15,
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.tkForm.zhpjjy),
      callback: function($$v) {
        _vm.$set(_vm.tkForm, "zhpjjy", $$v)
      },
      expression: "tkForm.zhpjjy"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价人"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.user.userName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "日期",
      "prop": "rq"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd hh:mm:ss"
    },
    model: {
      value: (_vm.tkForm.rq),
      callback: function($$v) {
        _vm.$set(_vm.tkForm, "rq", $$v)
      },
      expression: "tkForm.rq"
    }
  })], 1), _vm._v(" "), _c('el-form', {
    ref: "tkForm",
    attrs: {
      "model": _vm.tkForm,
      "label-width": "96px",
      "label-position": "top",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "教学过程组织和主要内容",
      "prop": "jxgcnr"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 15,
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.tkForm.jxgcnr),
      callback: function($$v) {
        _vm.$set(_vm.tkForm, "jxgcnr", $$v)
      },
      expression: "tkForm.jxgcnr"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.submit('03')
      }
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("退 出")])], 1)], 1), _vm._v(" "), (_vm.dialogVisible.tkEvaluateInfo) ? _c('div', [_c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": "详情",
      "visible": _vm.dialogVisible.tkEvaluateInfo,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogVisible, "tkEvaluateInfo", $event)
      }
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "tkMainDialogScroll"
    }
  }, [_c('el-form', {
    ref: "tkForm",
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "model": _vm.tkForm,
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评价项目"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.pjxData[_vm.tkEvaluateInfoIndex].pjxmc) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价权重"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.pjxData[_vm.tkEvaluateInfoIndex].qz) + "\n                        ")]), _vm._v(" "), _c('el-form', {
    ref: "tkForm",
    attrs: {
      "model": _vm.tkForm,
      "label-width": "96px",
      "label-position": "top",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评价指标"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.pjxData[_vm.tkEvaluateInfoIndex].pjxnr) + "\n                            ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评分标准"
    }
  }, [_vm._v("\n                            优:" + _vm._s(_vm.pjxData[_vm.tkEvaluateInfoIndex].y) + "\n                            良:" + _vm._s(_vm.pjxData[_vm.tkEvaluateInfoIndex].l) + "\n                            中:" + _vm._s(_vm.pjxData[_vm.tkEvaluateInfoIndex].z) + "\n                            差:" + _vm._s(_vm.pjxData[_vm.tkEvaluateInfoIndex].c) + "\n                        ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": "教师教学质量听课评价",
      "visible": _vm.dialogVisible.queryTkEvaluate
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogVisible, "queryTkEvaluate", $event)
      }
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "tkMainDialogScroll"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "96px",
      "label-position": "left",
      "width": "100%"
    }
  }, [(_vm.tkComboOption.tkbbh != '') ? _c('el-select', {
    on: {
      "change": function($event) {
        return _vm.showDetailInfo(_vm.tkComboOption.tkbbh, '03')
      }
    },
    model: {
      value: (_vm.tkComboOption.tkbbh),
      callback: function($$v) {
        _vm.$set(_vm.tkComboOption, "tkbbh", $$v)
      },
      expression: "tkComboOption.tkbbh"
    }
  }, _vm._l((_vm.tkComboOption.tkCombo), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "教师姓名"
    }
  }, [_c('div', [_vm._v("\n                            " + _vm._s(_vm.tkQueData.basicInfo.jsxm) + "\n                        ")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学年学期"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkQueData.basicInfo.xnxqmc) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "教师类型"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkQueData.basicInfo.jslx) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程类型"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkQueData.basicInfo.tkkclx) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "教师所在系部"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkQueData.basicInfo.jsxbmc) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程名称"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkQueData.basicInfo.kcmc) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "听课班级"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkQueData.basicInfo.tkbjmc) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "听课地点"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkQueData.basicInfo.jsmc) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "听课时间"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkQueData.basicInfo.tksj) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应到学生数"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkQueData.basicInfo.ydxss) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实到学生数"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkQueData.basicInfo.sdxss) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "迟到学生数"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkQueData.basicInfo.cdxss) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "得分:"
    }
  }), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "150px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_vm._l((_vm.tkQueData.pjxInfo), function(item, index) {
    return [_c('el-form-item', {
      attrs: {
        "label": item.pjxmc
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.openQueTkInfo(index)
        }
      }
    }, [_vm._v("详情")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_vm._v("\n                                    " + _vm._s(item.pf) + "\n                                ")])], 1)]
  })], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合计"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkQueData.hjdf) + "\n                    ")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "综合评价与建议"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.tkQueData.basicInfo.zhpjjy)
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价人"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkQueData.basicInfo.cjr) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "日期"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkQueData.basicInfo.cjsj) + "\n                    ")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "教学过程组织和主要内容"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.tkQueData.basicInfo.jxnrgc)
    }
  })])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.dialogVisible.queryTkEvaluateInfo) ? _c('div', [_c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": "详情",
      "visible": _vm.dialogVisible.queryTkEvaluateInfo,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogVisible, "queryTkEvaluateInfo", $event)
      }
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "tkMainDialogScroll"
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评价项目"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.tkQueData.pjxInfo[_vm.tkEvaluateInfoIndex].pjxmc) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价权重"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.tkQueData.pjxInfo[_vm.tkEvaluateInfoIndex].qz) + "\n                        ")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评价指标"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.tkQueData.pjxInfo[_vm.tkEvaluateInfoIndex].pjxnr) + "\n                            ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评分标准"
    }
  }, [_vm._v("\n                            优:" + _vm._s(_vm.tkQueData.pjxInfo[_vm.tkEvaluateInfoIndex].y) + "\n                            良:" + _vm._s(_vm.tkQueData.pjxInfo[_vm.tkEvaluateInfoIndex].l) + "\n                            中:" + _vm._s(_vm.tkQueData.pjxInfo[_vm.tkEvaluateInfoIndex].z) + "\n                            差:" + _vm._s(_vm.tkQueData.pjxInfo[_vm.tkEvaluateInfoIndex].c) + "\n                        ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dialogVisible.stuEvaluate) ? _c('div', [_c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": "教师教学质量评价（学生）",
      "visible": _vm.dialogVisible.stuEvaluate,
      "close-on-click-modal": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogVisible, "stuEvaluate", $event)
      },
      "close": function($event) {
        return _vm.closeStuXzrDialog()
      }
    }
  }, [_c('el-form', {
    ref: "pfForm",
    attrs: {
      "model": _vm.pfForm,
      "label-width": "84px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "20px",
      "width": "90%",
      "height": "12vh",
      "overflow": "hidden",
      "white-space": "nowrap",
      "text-overflow": "ellipsis"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "教师姓名"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuXzrTableData.teaData[_vm.pageNum.teaPageNum - 1].teaName) + "\n                        ")]), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.parseCourseName(_vm.stuXzrTableData.teaData[_vm.pageNum.teaPageNum - 1].courseName),
      "placement": "top"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "label": "课程"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.parseCourseName(_vm.stuXzrTableData.teaData[_vm.pageNum.teaPageNum - 1].courseName)) + "\n                            ")])], 1)], 1), _vm._v(" "), _c('el-scrollbar', {
    ref: "stuMainDialogScroll",
    attrs: {
      "id": "pfMainDialogScroll"
    }
  }, [_c('div', {
    ref: "stuRef"
  }, [_c('div', {
    ref: "stuWindowRef"
  }, [_vm._l((_vm.stuXzrTableData.pjxData), function(item, index) {
    return [_c('div', {
      class: "divider" + index
    }, [_c('el-divider')], 1), _vm._v(" "), _c('el-form', {
      ref: "pfForm",
      refInFor: true,
      attrs: {
        "model": _vm.pfForm,
        "label-width": "130px",
        "label-position": "left",
        "width": "100%"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": item.xh + '.评价项目(权重)'
      }
    }, [_vm._v("\n                                            " + _vm._s(item.pjxmc) + "(" + _vm._s(item.qz) + ")\n                                        ")])], 1), _vm._v(" "), _c('el-form', {
      attrs: {
        "label-position": "top",
        "width": "100%"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "评价标准"
      }
    }, [_vm._v("\n                                            " + _vm._s(item.pjxnr) + "\n                                        ")])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "评分",
        "prop": 'pfArr[' + (_vm.pageNum.teaPageNum - 1) + '][' + index + ']',
        "rules": [{
          required: true,
          message: ' '
        }]
      }
    }, [_c('el-input-number', {
      attrs: {
        "size": "mini",
        "min": 0,
        "max": _vm.qzArr[_vm.pageNum.teaPageNum - 1][index]
      },
      on: {
        "input": function($event) {
          return _vm.changePf($event, _vm.pageNum.teaPageNum - 1, index)
        }
      },
      model: {
        value: (_vm.pfForm.pfArr[_vm.pageNum.teaPageNum - 1][index]),
        callback: function($$v) {
          _vm.$set(_vm.pfForm.pfArr[_vm.pageNum.teaPageNum - 1], index, $$v)
        },
        expression: "pfForm.pfArr[pageNum.teaPageNum-1][index]"
      }
    })], 1)]
  })], 2)])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "pfInputDialogScroll"
    }
  }, [_c('div', [_c('el-pagination', {
    ref: "pagin",
    attrs: {
      "small": "",
      "prev-text": "上一页",
      "next-text": "下一页",
      "layout": "prev, slot, next",
      "total": parseInt(_vm.stuXzrTableData.teaData.length + '0'),
      "current-page": _vm.pageNum.pageNumColumn
    },
    on: {
      "current-change": _vm.getTeaPageNum,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pageNum, "pageNumColumn", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pageNum, "pageNumColumn", $event)
      }
    }
  }, [_vm._v("\n\n                                          \n                            "), _c('span', [_c('span', {
    staticClass: "leftSpan"
  }, [_vm._v(_vm._s(_vm.pageNum.teaPageNum))]), _vm._v("/"), _c('span', [_vm._v(_vm._s(_vm.stuXzrTableData.teaData.length))])]), _vm._v("\n                                          \n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.submit('01')
      }
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("退 出")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dialogVisible.queryStuEvaluate) ? _c('div', [_c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": "教师教学质量评价（学生）",
      "visible": _vm.dialogVisible.queryStuEvaluate,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogVisible, "queryStuEvaluate", $event)
      }
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "mainDialogScroll"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "84px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "教师姓名"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuQueData[_vm.pageNum.teaPageNum - 1][0].teaName) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.parseCourseName(_vm.stuQueData[_vm.pageNum.teaPageNum - 1][0].courseName)) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价项目"
    }
  }), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "150px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_vm._l((_vm.stuQueData[_vm.pageNum.teaPageNum - 1]), function(item, index) {
    return [_c('el-form-item', {
      attrs: {
        "label": item.xh + ' ' + item.pjxmc + ':'
      }
    }, [_vm._v("\n                                    " + _vm._s(item.df) + "\n                                    "), _c('el-button', {
      staticStyle: {
        "margin-left": "20px"
      },
      attrs: {
        "size": "mini",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.openQueStuInfo(index)
        }
      }
    }, [_vm._v("详情\n                                    ")])], 1)]
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-pagination', {
    attrs: {
      "small": "",
      "prev-text": "上一页",
      "next-text": "下一页",
      "layout": "prev, slot, next",
      "total": parseInt(_vm.stuQueData.length + '0'),
      "current-page": _vm.pageNum.pageNumColumn
    },
    on: {
      "current-change": _vm.getTeaPageNum,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pageNum, "pageNumColumn", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pageNum, "pageNumColumn", $event)
      }
    }
  }, [_c('span', [_c('span', {
    staticClass: "leftSpan"
  }, [_vm._v(_vm._s(_vm.pageNum.teaPageNum))]), _vm._v("/"), _c('span', [_vm._v(_vm._s(_vm.stuQueData.length))])])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dialogVisible.queryStuEvaluateInfo) ? _c('div', [_c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": "详情",
      "visible": _vm.dialogVisible.queryStuEvaluateInfo,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogVisible, "queryStuEvaluateInfo", $event)
      }
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "mainDialogScroll"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "84px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "序号"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuQueData[_vm.pageNum.teaPageNum - 1][_vm.stuEvaluateInfoIndex].xh) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价项目"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuQueData[_vm.pageNum.teaPageNum - 1][_vm.stuEvaluateInfoIndex].pjxmc) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价权重"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuQueData[_vm.pageNum.teaPageNum - 1][_vm.stuEvaluateInfoIndex].qz) + "\n                        ")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评价标准"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.stuQueData[_vm.pageNum.teaPageNum - 1][_vm.stuEvaluateInfoIndex].pjxnr) + "\n                            ")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dialogVisible.xzrEvaluate) ? _c('div', [_c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": "教师教学质量评价（系主任）",
      "visible": _vm.dialogVisible.xzrEvaluate,
      "close-on-click-modal": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogVisible, "xzrEvaluate", $event)
      },
      "close": function($event) {
        return _vm.closeStuXzrDialog()
      }
    }
  }, [_c('el-form', {
    ref: "pfForm",
    attrs: {
      "model": _vm.pfForm,
      "label-width": "84px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "20px",
      "width": "90%",
      "height": "12vh",
      "overflow": "hidden",
      "white-space": "nowrap",
      "text-overflow": "ellipsis"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "教师姓名"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuXzrTableData.teaData[_vm.pageNum.teaPageNum - 1].teaName) + "\n                        ")]), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.parseCourseName(_vm.stuXzrTableData.teaData[_vm.pageNum.teaPageNum - 1].courseName),
      "placement": "top"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "label": "课程"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.parseCourseName(_vm.stuXzrTableData.teaData[_vm.pageNum.teaPageNum - 1].courseName)) + "\n                            ")])], 1)], 1), _vm._v(" "), _c('el-scrollbar', {
    ref: "stuMainDialogScroll",
    attrs: {
      "id": "pfMainDialogScroll"
    }
  }, [_c('div', {
    ref: "stuRef"
  }, [_c('div', {
    ref: "stuWindowRef"
  }, [_vm._l((_vm.stuXzrTableData.pjxData), function(item, index) {
    return [_c('div', {
      class: "divider" + index
    }, [_c('el-divider')], 1), _vm._v(" "), _c('el-form', {
      ref: "pfForm",
      refInFor: true,
      attrs: {
        "model": _vm.pfForm,
        "label-width": "130px",
        "label-position": "left",
        "width": "100%"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": item.xh + '.评价项目(权重)'
      }
    }, [_vm._v("\n                                            " + _vm._s(item.pjxmc) + "(" + _vm._s(_vm.sfzrQz(_vm.pageNum.teaPageNum - 1, index)) + ")\n                                        ")])], 1), _vm._v(" "), _c('el-form', {
      attrs: {
        "label-position": "top",
        "width": "100%"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "评价标准"
      }
    }, [_vm._v("\n                                            " + _vm._s(item.pjxnr) + "\n                                        ")])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "评分标准"
      }
    }, [_vm._v("\n                                        " + _vm._s(_vm.sfzrPfbz(_vm.pageNum.teaPageNum - 1, index)) + "\n                                    ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "评分",
        "prop": 'pfArr[' + (_vm.pageNum.teaPageNum - 1) + '][' + index + ']',
        "rules": [{
          required: true,
          message: ' '
        }]
      }
    }, [_c('el-input-number', {
      attrs: {
        "size": "mini",
        "min": 0,
        "max": _vm.sfzr(_vm.pageNum.teaPageNum - 1, index)
      },
      on: {
        "input": function($event) {
          return _vm.changePf($event, _vm.pageNum.teaPageNum - 1, index)
        }
      },
      model: {
        value: (_vm.pfForm.pfArr[_vm.pageNum.teaPageNum - 1][index]),
        callback: function($$v) {
          _vm.$set(_vm.pfForm.pfArr[_vm.pageNum.teaPageNum - 1], index, $$v)
        },
        expression: "pfForm.pfArr[pageNum.teaPageNum-1][index]"
      }
    })], 1)]
  })], 2)])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "pfInputDialogScroll"
    }
  }, [_c('div', [_c('el-pagination', {
    ref: "pagin",
    attrs: {
      "small": "",
      "prev-text": "上一页",
      "next-text": "下一页",
      "layout": "prev, slot, next",
      "total": parseInt(_vm.stuXzrTableData.teaData.length + '0'),
      "current-page": _vm.pageNum.pageNumColumn
    },
    on: {
      "current-change": _vm.getTeaPageNum,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pageNum, "pageNumColumn", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pageNum, "pageNumColumn", $event)
      }
    }
  }, [_vm._v("\n\n                                          \n                            "), _c('span', [_c('span', {
    staticClass: "leftSpan"
  }, [_vm._v(_vm._s(_vm.pageNum.teaPageNum))]), _vm._v("/"), _c('span', [_vm._v(_vm._s(_vm.stuXzrTableData.teaData.length))])]), _vm._v("\n                                          \n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.submit('02')
      }
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("退 出")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dialogVisible.queryXzrEvaluate) ? _c('div', [_c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": "教师教学质量评价（系主任）",
      "visible": _vm.dialogVisible.queryXzrEvaluate,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogVisible, "queryXzrEvaluate", $event)
      }
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "mainDialogScroll"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "84px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "教师姓名"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.xzrQueData[_vm.pageNum.teaPageNum - 1][0].teaName) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.parseCourseName(_vm.xzrQueData[_vm.pageNum.teaPageNum - 1][0].courseName)) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价项目"
    }
  }), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "150px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_vm._l((_vm.xzrQueData[_vm.pageNum.teaPageNum - 1]), function(item, index) {
    return [_c('el-form-item', {
      attrs: {
        "label": item.xh + ' ' + item.pjxmc + ':'
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.openQueXzrInfo(index)
        }
      }
    }, [_vm._v("详情\n                                    ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_vm._v("\n                                        " + _vm._s(item.df) + "\n                                    ")])], 1)]
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-pagination', {
    attrs: {
      "small": "",
      "prev-text": "上一页",
      "next-text": "下一页",
      "layout": "prev, slot, next",
      "total": parseInt(_vm.xzrQueData.length + '0'),
      "current-page": _vm.pageNum.pageNumColumn
    },
    on: {
      "current-change": _vm.getTeaPageNum,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pageNum, "pageNumColumn", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pageNum, "pageNumColumn", $event)
      }
    }
  }, [_c('span', [_c('span', {
    staticClass: "leftSpan"
  }, [_vm._v(_vm._s(_vm.pageNum.teaPageNum))]), _vm._v("/"), _c('span', [_vm._v(_vm._s(_vm.xzrQueData.length))])])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dialogVisible.queryXzrEvaluateInfo) ? _c('div', [_c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": "详情",
      "visible": _vm.dialogVisible.queryXzrEvaluateInfo,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogVisible, "queryXzrEvaluateInfo", $event)
      }
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "xzrMainDialogScroll"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "84px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "序号"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.xzrQueData[_vm.pageNum.teaPageNum - 1][_vm.xzrEvaluateInfoIndex].xh) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价项目"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.xzrQueData[_vm.pageNum.teaPageNum - 1][_vm.xzrEvaluateInfoIndex].pjxmc) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价权重"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.xzrQueData[_vm.pageNum.teaPageNum - 1][_vm.xzrEvaluateInfoIndex].qz) + "\n                        ")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评价标准"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.xzrQueData[_vm.pageNum.teaPageNum - 1][_vm.xzrEvaluateInfoIndex].pjxnr) + "\n                            ")])], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评分标准"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.xzrQueData[_vm.pageNum.teaPageNum - 1][_vm.xzrEvaluateInfoIndex].pfbzsm)
    }
  })])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "visible": _vm.dialogVisible.tkjlEvaluate,
      "close-on-click-modal": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogVisible, "tkjlEvaluate", $event)
      },
      "open": _vm.openTkjl,
      "closed": _vm.closeTkjl
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticStyle: {
      "color": "#303133",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.tkjlTitle))]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "#409eff",
      "border": "none",
      "width": "70px",
      "height": "30px",
      "margin-left": "20px"
    },
    on: {
      "click": _vm.openCkzb
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "color": "#FFFFFF"
    }
  }, [_vm._v("参考指标")])])]), _vm._v(" "), _c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "mainDialogScroll"
    }
  }, [_c('el-form', {
    ref: "tkjlForm",
    attrs: {
      "model": _vm.tkjlForm,
      "label-width": "96px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学年学期"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.semesterName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课教师",
      "prop": "teaCode",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.tkjlTeaChange
    },
    model: {
      value: (_vm.tkjlForm.teaCode),
      callback: function($$v) {
        _vm.$set(_vm.tkjlForm, "teaCode", $$v)
      },
      expression: "tkjlForm.teaCode"
    }
  }, _vm._l((_vm.tkjlComboOption.tea), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "教师所在系部"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlForm.deptName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课班级"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlForm.className) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课地点",
      "prop": "site",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.tkjlForm.site),
      callback: function($$v) {
        _vm.$set(_vm.tkjlForm, "site", $$v)
      },
      expression: "tkjlForm.site"
    }
  }, _vm._l((_vm.tkjlComboOption.site), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程名称",
      "prop": "courseCode",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "change": _vm.tkjlCourseChange
    },
    model: {
      value: (_vm.tkjlForm.courseCode),
      callback: function($$v) {
        _vm.$set(_vm.tkjlForm, "courseCode", $$v)
      },
      expression: "tkjlForm.courseCode"
    }
  }, _vm._l((_vm.tkjlComboOption.course), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    }, [_c('div', {
      attrs: {
        "slot": ""
      },
      slot: "default"
    }, [_vm._v(_vm._s(item.className + " - (" + item.comboName + ")"))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课题",
      "prop": "kt",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "500"
    },
    model: {
      value: (_vm.tkjlForm.kt),
      callback: function($$v) {
        _vm.$set(_vm.tkjlForm, "kt", $$v)
      },
      expression: "tkjlForm.kt"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "听课日期",
      "prop": "date",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.tkjlForm.date),
      callback: function($$v) {
        _vm.$set(_vm.tkjlForm, "date", $$v)
      },
      expression: "tkjlForm.date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "听课节次",
      "prop": "time",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "multiple-limit": 3,
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.tkjlForm.time),
      callback: function($$v) {
        _vm.$set(_vm.tkjlForm, "time", $$v)
      },
      expression: "tkjlForm.time"
    }
  }, _vm._l((_vm.tkjlComboOption.time), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "按时上课（√）",
      "prop": "assk",
      "label-width": "135px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.tkjlForm.assk),
      callback: function($$v) {
        _vm.$set(_vm.tkjlForm, "assk", $$v)
      },
      expression: "tkjlForm.assk"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "迟到（分钟）",
      "prop": "cd",
      "rules": [{
        required: true,
        message: ' '
      }],
      "label-width": "135px"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.tkjlForm.cd),
      callback: function($$v) {
        _vm.$set(_vm.tkjlForm, "cd", $$v)
      },
      expression: "tkjlForm.cd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提前下课（分钟）",
      "prop": "tqxk",
      "rules": [{
        required: true,
        message: ' '
      }],
      "label-width": "135px"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.tkjlForm.tqxk),
      callback: function($$v) {
        _vm.$set(_vm.tkjlForm, "tqxk", $$v)
      },
      expression: "tkjlForm.tqxk"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应到人数",
      "label-width": "135px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlForm.ydxss) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实到人数",
      "prop": "sdrs",
      "rules": [{
        required: true,
        message: ' '
      }],
      "label-width": "135px"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.tkjlForm.sdrs),
      callback: function($$v) {
        _vm.$set(_vm.tkjlForm, "sdrs", $$v)
      },
      expression: "tkjlForm.sdrs"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "迟到人数",
      "prop": "cdrs",
      "rules": [{
        required: true,
        message: ' '
      }],
      "label-width": "135px"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.tkjlForm.cdrs),
      callback: function($$v) {
        _vm.$set(_vm.tkjlForm, "cdrs", $$v)
      },
      expression: "tkjlForm.cdrs"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "迟到最长（分钟）",
      "prop": "cdrs",
      "rules": [{
        required: true,
        message: ' '
      }],
      "label-width": "135px"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.tkjlForm.cdzc),
      callback: function($$v) {
        _vm.$set(_vm.tkjlForm, "cdzc", $$v)
      },
      expression: "tkjlForm.cdzc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "早退人数",
      "prop": "ztrs",
      "rules": [{
        required: true,
        message: ' '
      }],
      "label-width": "135px"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.tkjlForm.ztrs),
      callback: function($$v) {
        _vm.$set(_vm.tkjlForm, "ztrs", $$v)
      },
      expression: "tkjlForm.ztrs"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课过程记录",
      "prop": "skgcjl",
      "rules": [{
        required: true,
        message: ' '
      }],
      "label-width": "300px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "skgcjl",
      "rules": [{
        required: true,
        message: ' '
      }],
      "label-width": "0"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 15,
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.tkjlForm.skgcjl),
      callback: function($$v) {
        _vm.$set(_vm.tkjlForm, "skgcjl", $$v)
      },
      expression: "tkjlForm.skgcjl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "教学建议",
      "prop": "jxjy",
      "rules": [{
        required: true,
        message: ' '
      }],
      "label-width": "300px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "jxjy",
      "rules": [{
        required: true,
        message: ' '
      }],
      "label-width": "0"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 15,
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.tkjlForm.jxjy),
      callback: function($$v) {
        _vm.$set(_vm.tkjlForm, "jxjy", $$v)
      },
      expression: "tkjlForm.jxjy"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价等级",
      "prop": "pjdj",
      "rules": [{
        required: true,
        message: ' '
      }],
      "label-width": "300px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "pjdj",
      "rules": [{
        required: true,
        message: ' '
      }],
      "label-width": "0"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.tkjlForm.pjdj),
      callback: function($$v) {
        _vm.$set(_vm.tkjlForm, "pjdj", $$v)
      },
      expression: "tkjlForm.pjdj"
    }
  }, _vm._l((_vm.tkjlComboOption.pjdj), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.submit('tkjl')
      }
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("退 出")])], 1)], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": _vm.ckzbTitle,
      "visible": _vm.dialogVisible.ckzb
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogVisible, "ckzb", $event)
      }
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "mainDialogScroll"
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "目标与学情"
    }
  }, [(_vm.tkjlType === 'gg') ? _c('span', [_vm._v("1.符合新时代对技术技能人才培养新要求，落实教育部颁布的公共基础课程教学标准有关要求，紧扣学校专业人才培养方案和课程教学安排，夯实学生科学文化基础，着力培养学生人文素养、职业素养、信息素养，培养学生工匠精神、科学精神、创新精神和终身学习能力。"), _c('br'), _vm._v("2.教学目标表述明确、相互关联，重点突出、可评可测。"), _c('br'), _vm._v("3.客观分析学生知识基础、认知能力、学习特点、专业特性等，详实反映学生整体情况与个体差异，准确预判教学难点。")]) : _c('span', [_vm._v("1.适应新时代对高素质技术技能人才培养的新要求，符合教育部发布的专业教学标准、实训教学条件建设标准、岗位实习标准等有关要求，涉及职业技能等级证书的课程教学内容，还应对接有关职业技能等级标准。紧扣学校专业人才培养方案和课程标准，夯实学生专业基础和专业能力，培育学生职业道德、职业能力、信息素养、创新能力、工程思维，培养学生科学精神、工匠精神和终身学习能力。"), _c('br'), _vm._v("2.教学目标表述明确、相互关联，重点突出、可评可测。"), _c('br'), _vm._v("3.客观分析学生的知识和技能基础、认知和实践能力、学习特点等，详实反映学生整体情况与个体差异，准确预判教学难点。")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容与策略"
    }
  }, [(_vm.tkjlType === 'gg') ? _c('span', [_vm._v("1.思政课程按照“八个相统一”要求扎实推进创优建设；其他课程注重落实课程思政要求，结合课程特点挖掘思政元素，有机融入课程教学，达到润物无声的育人效果。"), _c('br'), _vm._v("2.教学内容落实公共基础课程课标，突出思想性、科学性、基础性、职业性和时代性，有效支撑教学目标的实现，内容选择科学严谨、容量适度，安排合理、衔接有序、结构清晰，符合层次定位。"), _c('br'), _vm._v("3.教材选用、使用符合《职业院校教材管理办法》等文件规定和要求，配套提供丰富、优质学习资源；教案完整、规范、简明、真实。"), _c('br'), _vm._v("4.教学设计科学合理，教学过程系统优化，流程环节构思得当，技术应用预想合理，方法手段设计恰当，评价考核科学有效。")]) : _c('span', [_vm._v("1.结合课程特点、思维方法和价值理念，挖掘提炼专业知识体系中所蕴含的思想价值和精神内涵，有机融入课程教学，达到润物无声的育人效果。"), _c('br'), _vm._v("2.教学内容落实课程标准，对接新产业、新业态、新模式、新职业，促进书证融通，有效支撑教学目标的实现，内容选择科学严谨、容量适度，安排合理、衔接有序、结构清晰，符合层次定位；实习实训内容与专业课程教学内容匹配，强化核心技术技能训练。"), _c('br'), _vm._v("3.教材选用符合《职业院校教材管理办法》等文件规定和要求，配套提供丰富、优质学习资源，鼓励使用新型活页式、工作手册式教材；教案完整、规范、简明、真实。"), _c('br'), _vm._v("4.教学设计合理，教学过程系统优化，流程环节构思得当，技术应用预想合理，方法手段设计恰当，评价考核科学有效，突出项目式、任务式、案例式、情境式等教学方式。")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实施与成效"
    }
  }, [(_vm.tkjlType === 'gg') ? _c('span', [_vm._v("1.教育思想和教学理念先进，遵循学生认知规律，反映日常教学实际。"), _c('br'), _vm._v("2.按照授课计划实施教学，关注重点、难点的解决，能够针对学习反馈及时调整教学，突出学生中心，实行因材施教。"), _c('br'), _vm._v("3.教学环境真实，满足教学需要，教学活动开展有序，教学互动深入有效，教学气氛生动活泼，学生学有所得。"), _c('br'), _vm._v("4.关注教与学行为数据采集，针对目标要求开展考核与评价。"), _c('br'), _vm._v("5.创新教学方式方法，合理运用前沿信息技术、数字化教学资源、设施设备改造传统教学，提升学习效果、提高教学与管理成效。")]) : _c('span', [_vm._v("1.教育思想和教学理念先进，落实德技并修、工学结合，遵循职业教育规律、学生认知规律和技术技能人才成长规律，反映日常教学实际。"), _c('br'), _vm._v("2.按照授课计划实施教学，关注技术技能教学重点、难点的解决，能够针对学习和实践反馈及时调整教学，突出学生中心，落实理实一体化，强调知行合一，实行因材施教；针对不同生源特点，体现灵活的教学组织形式。"), _c('br'), _vm._v("3.教学环境真实，能够满足教学需要，教学活动安全有序，教学互动深入有效，教学气氛生动活泼，学生乐学、学会。"), _c('br'), _vm._v("4.关注教与学行为数据采集，针对目标要求开展教学与实践的考核与评价。"), _c('br'), _vm._v("5.创新教学方式方法，合理运用前沿信息技术、数字化资源、设施设备改造传统教学与实习实训，提升学习效果，提高教学与管理效能。")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "教学素养"
    }
  }, [(_vm.tkjlType === 'gg') ? _c('span', [_vm._v("1.展现新时代职业院校教师良好的师德师风、教学能力和信息素养。"), _c('br'), _vm._v("2.教师课堂教学态度认真、严谨规范、表述清晰、亲和力强、仪态自然。"), _c('br'), _vm._v("3.教学研究深入，学术功底扎实。")]) : _c('span', [_vm._v("1.展现新时代职业院校教师良好的师德师风、教学能力、实践能力和信息素养。"), _c('br'), _vm._v("2.课堂教学态度认真、严谨规范、表述清晰、亲和力强、仪态自然。"), _c('br'), _vm._v("3.实训教学讲解和操作配合恰当，规范娴熟、示范有效，符合职业岗位要求，展现良好“双师”素养。"), _c('br'), _vm._v("4.教学研究深入，学术功底扎实。")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "特色创新"
    }
  }, [(_vm.tkjlType === 'gg') ? _c('span', [_vm._v("1.在落实立德树人、文化素养提升、课程思政建设等方面有行之有效的做法，能够调动学生全面深度参与，给学生深刻的学习体验。"), _c('br'), _vm._v("2.在落实国家教学标准、推进“三教”改革、运用信息技术等方面有特色、有创新。"), _c('br'), _vm._v("3.具有较大借鉴和推广价值。")]) : _c('span', [_vm._v("1.在落实立德树人、德技并修，课程思政，工学结合、知行合一等方面有行之有效的做法，能够调动学生全面深度参与，给学生深刻的学习体验，促进学生职业综合素质和行动能力的明显提升。"), _c('br'), _vm._v("2.在落实国家教学标准、推进“三教”改革、运用信息技术等方面有特色、有创新。"), _c('br'), _vm._v("3.具有较大借鉴和推广价值。")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible.ckzb = false
      }
    }
  }, [_vm._v("关 闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "visible": _vm.dialogVisible.queryTkjlEvaluate
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogVisible, "queryTkjlEvaluate", $event)
      }
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticStyle: {
      "color": "#303133",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.tkjlTitle))]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "#409eff",
      "border": "none",
      "width": "70px",
      "height": "30px",
      "margin-left": "20px"
    },
    on: {
      "click": _vm.openCkzb
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "color": "#FFFFFF"
    }
  }, [_vm._v("参考指标")])])]), _vm._v(" "), _c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "mainDialogScroll"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "96px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学年学期"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlQueData.xnxqmc) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlQueData.jsxm) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "教师所在系部"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlQueData.jsxbmc) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课班级"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlQueData.tkbjmc) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlQueData.jsmc) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程名称"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlQueData.kcmc) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课题"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlQueData.kt) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "听课日期"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlQueData.tkrq) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "听课节次"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlQueData.tkjc) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "按时上课（√）",
      "label-width": "135px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlQueData.sfassk) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "迟到（分钟）",
      "label-width": "135px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlQueData.skcdsj) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提前下课（分钟）",
      "label-width": "135px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlQueData.tqxksj) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应到人数",
      "label-width": "135px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlQueData.ydxss) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实到人数",
      "label-width": "135px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlQueData.sdxss) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "迟到人数",
      "label-width": "135px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlQueData.cdxss) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "迟到最长（分钟）",
      "label-width": "135px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlQueData.cdzcsj) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "早退人数",
      "label-width": "135px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlQueData.ztxss) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授课过程记录",
      "label-width": "300px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "0"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.tkjlQueData.jxnrgc)
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "教学建议",
      "label-width": "300px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "0"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.tkjlQueData.zhpjjy)
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价等级",
      "label-width": "300px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "0"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.tkjlQueData.pjdj) + "\n                    ")])], 1)], 1)], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57a3fd3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/questionnaireServerMobile.vue
// module id = 1835
// module chunks = 502